import ChangeEmail from "@/components/profile/change-email";
import ChangePassword from "@/components/profile/change-password";
import JwtClaims from "@/components/profile/jwt-claims";
import UserInfo from "@/components/profile/user-info";
import Card from 'react-bootstrap/Card';
import { useUserData } from "@nhost/react"; // ✅ Import pour récupérer les rôles
import { IoWarningOutline } from "react-icons/io5";

const warn = <div className="d-flex align-items-center text-warning gap-2">
              <IoWarningOutline /> Attention page en développement <IoWarningOutline />
             </div>

export default function Profile() {
  const userData = useUserData();
  const roles = userData?.roles || [];

  return (
    <div className="flex flex-col w-full gap-4">
      <Card className="w-full">
        <Card.Body>
          <Card.Title>{warn}</Card.Title>
        </Card.Body>
      </Card>

      <ChangeEmail />
      <ChangePassword />
      <UserInfo />
      <JwtClaims />
    </div>
  );
}
